import axios from 'axios';
import { IS_BROWSER_MAIN_THREAD, IS_WEB } from './../consts.js';

/*************** FAKE ANGULAR $Q ***************/
// It's needed when we import angular code.

let $q = {
    when: function (a) {
        return new Promise(resolve => {
            resolve(a);
        })
    }
}

/*************** FAKE ANGULAR ***************/
// It's needed when we import angular code.

let factoryReturns = {};

let angular = {
    module() {
        return angular;
    },
    directive() {
        return angular;
    },
    factory(name, args) {
        try {
            if (typeof args === 'object') {
                factoryReturns[name] = args[args.length - 1]($q);
            } else {
                factoryReturns[name] = args($q);
            }
        } catch (error) {
            console.log('Errror in data type: ', name);
            console.log(error);
        }
        return angular;
    },
    service() {
        return angular;
    },
    run() {
        return angular;
    },
    filter() {
        return angular;
    },
    controller() {
        return angular;
    },
    value() {
        return angular;
    },
    element() {
        return angular;
    },
    injector() {
        return angular;
    },
    invoke() {
        return angular;
    }
}

/*************** CREATE INSTANCE ***************/
// Here we are importing modules using dynamic import.
// For browser: just do dynamic import with url as parameter.
// In node environment we can't dynamically import module from url, so we download module's code via axios and transform it to data url.
// Then creating classes from imported modules.
// Finally, creating instance of module, using functions from imported classes. If we in browser - also takes methods from angular's injector.

/*** TODO ***/
// Need to make angular modules instances creation similar to pure js classes.

export default async function createAngularModuleInstance(gudhub, module_id, module_url, angularInjector, nodeWindow) {

    try {

        let angularModule;
        let importedClass;

        if (IS_BROWSER_MAIN_THREAD) {

            if(window.angular) {

                // Download module with $ocLazyLoad if module not in injector already.

                if (!angularInjector.has(module_id)) {
                    await angularInjector.get('$ocLazyLoad').load(module_url);
                }

                angularModule = await angularInjector.get(module_id);

                // Then, dynamically import modules from url.

                let module = await axios.get(module_url);
                module = module.data;

                try {
                    eval(module);
                } catch (error) {
                    console.error(`ERROR WHILE EVAL() IN GHCONSTRUCTOR. MODULE ID: ${module_id}`);
                    console.log(error);
                }

                importedClass = factoryReturns[module_id];

            } else {

                let module = await axios.get(module_url);
                module = module.data;

                try {
                    eval(module);
                } catch (err) {
                    console.log(`Error while importing module: ${module_id}`);
                    console.log(err);
                }

                // Modules always exports classes as default, so we create new class instance.

                importedClass = factoryReturns[module_id];

            }

        } else {

            const proxy = new Proxy(nodeWindow, {
                get: (target, property) => {
                    return target[property]
                },
                set: (target, property, value) => {
                    target[property] = value;
                    global[property] = value;
                    return true;
                }
            })

            // If node's global object don't have window and it's methods yet - set it.
            if (!global.hasOwnProperty('window')) {
                global.window = proxy;
                global.document = nodeWindow.document;
                global.Element = nodeWindow.Element;
                global.CharacterData = nodeWindow.CharacterData;
                global.this = proxy;
                global.self = proxy;
                global.Blob = nodeWindow.Blob;
                global.Node = nodeWindow.Node;
                global.navigator = nodeWindow.navigator;
                global.HTMLElement = nodeWindow.HTMLElement;
                global.XMLHttpRequest = nodeWindow.XMLHttpRequest;
                global.WebSocket = nodeWindow.WebSocket;
                global.crypto = nodeWindow.crypto;
                global.DOMParser = nodeWindow.DOMParser;
                global.Symbol = nodeWindow.Symbol;
                global.document.queryCommandSupported = (command) => {
                    return false;
                }
                global.angular = angular;
            }

            // Downloading module's code and transform it to data url.

            let response = await axios.get(module_url);
            let code = response.data;
            let encodedCode = encodeURIComponent(code);
            encodedCode = 'data:text/javascript;charset=utf-8,' + encodedCode;

            let module;

            // Then, dynamically import modules from data url.

            try {
                module = await import(/* webpackIgnore: true */encodedCode);
            } catch (err) {
                console.log(`Error while importing module: ${module_id}`);
                console.log(err);
            }

            // Modules always exports classes as default, so we create new class instance.

            importedClass = new module.default();

        }

        let result = {
            type: module_id,

            //*************** GET TEMPLATE ****************//

            getTemplate: function (ref, changeFieldName, displayFieldName, field_model, appId, itemId) {
                let displayFieldNameChecked = displayFieldName === 'false' ? false : true;
                return importedClass.getTemplate(ref, changeFieldName, displayFieldNameChecked, field_model, appId, itemId);
            },

            //*************** GET DEFAULT VALUE ****************//

            getDefaultValue: function (fieldModel, valuesArray, itemsList, currentAppId) {
                return new Promise(async (resolve) => {
                    let getValueFunction = importedClass.getDefaultValue;
                    if (getValueFunction) {
                        let value = await getValueFunction(fieldModel, valuesArray, itemsList, currentAppId);
                        resolve(value);
                    } else {
                        resolve(null);
                    }
                });
            },

            //*************** GET SETTINGS ****************//

            getSettings: function (scope, settingType, fieldModels) {
                return importedClass.getSettings(scope, settingType, fieldModels);
            },

            //*************** FILTER****************//

            filter: {
                getSearchOptions: function (fieldModel) {
                    let d_type = importedClass;
                    if (d_type.filter && d_type.filter.getSearchOptions) {
                        return importedClass.filter.getSearchOptions(fieldModel) || null;
                    }
                    return [];
                },
                getDropdownValues: function () {
                    let d_type = importedClass;
                    if (d_type.filter && d_type.filter.getDropdownValues) {
                        return d_type.filter.getDropdownValues() || null;
                    } else {
                        return [];
                    }
                }
            },

            //*************** GET INTERPRETATION ****************//

            getInterpretation: function (value, interpretation_id, dataType, field, itemId, appId) {
                return new Promise(async (resolve) => {
                    let currentDataType = importedClass;

                    try {
                        let interpr_arr = await currentDataType.getInterpretation(gudhub, value, appId, itemId, field, dataType);
                        let data = interpr_arr.find((item) => item.id == interpretation_id) || interpr_arr.find((item) => item.id == 'default');

                        let result = await data.content()

                        resolve({ html: result });
                    } catch (error) {
                        console.log(`ERROR IN ${module_id}`, error);
                        resolve({ html: '<span>no interpretation</span>' })
                    }
                });
            },

            //*************** GET INTERPRETATIONS LIST ****************//

            getInterpretationsList: function (field_value, appId, itemId, field) {
                return importedClass.getInterpretation(field_value, appId, itemId, field);
            },

            //*************** GET INTERPRETATED VALUE ****************//

            getInterpretatedValue: function (field_value, field_model, appId, itemId) {
                return new Promise(async (resolve) => {
                    let getInterpretatedValueFunction = importedClass.getInterpretatedValue;
                    if (getInterpretatedValueFunction) {
                        let value = await getInterpretatedValueFunction(field_value, field_model, appId, itemId);
                        resolve(value);
                    } else {
                        resolve(field_value);
                    }
                });
            },

            //*************** ON MESSAGE ****************//

            onMessage: function(appId, userId, response) {
                return new Promise(async (resolve) => {
                    const onMessageFunction = importedClass.onMessage;
                    if(onMessageFunction) {
                        const result = await onMessageFunction(appId, userId, response);
                        resolve(result);
                    }
                    resolve(null);
                })
            },
        }

        // We need these methods in browser environment only

        if (IS_BROWSER_MAIN_THREAD) {

            //*************** EXTEND CONTROLLER ****************//

            result.extendController = function (actionScope) {
                angularModule.getActionScope(actionScope);
            }

            //*************** RUN ACTION ****************//

            result.runAction = function (scope) {
                try {
                    angularModule.runAction(scope);
                } catch (e) {

                }
            }

            //*************** GET WINDOW SCOPE ****************//

            result.getWindowScope = function (windowScope) {
                return angularModule.getWindowScope(windowScope);
            }

            //*************** GET WINDOW HTML ****************//

            result.getWindowHTML = function (scope) {
                return angularModule.getWindowHTML(scope);
            }

        }

        return result;

    } catch (err) {
        console.log(err);
        console.log(`Failed in createAngularModuleInstance (ghconstructor). Module id: ${module_id}.`);
    }
}